import React from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Topbar } from "@components";
import styled from "styled-components";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useTranslation } from "react-i18next";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";

const RootContainer = styled.div`
	display: flex;
	padding: 20px 16px;
	flex-direction: column;
	gap: 12px;
`;

const Title = styled.div`
	width: 100%;
	background-color: #F8EEFF;
	padding: 4px 12px;
	border-radius: 12px;

	color: #49028E;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 24px;

`;

const RulesContainer = styled.div`
	color: #5D5189 !important;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 24.7px;

`;

const Rules = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { state } = useLocation();
	const userPreferedLanguage = localStorage.getUserPreferedLanguage();

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
	};

	if (!state) {
		return <Navigate to={`/${PUBLIC_ROUTE.SPIN_HOME}`} />;
	}

	const ruleText =
		userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
			? state.text_en
			: userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
			? state.text_mm
			: state.text_ch;
	return (
		<>
			<Topbar title={t("spin.rule")} goBack={goBack} shadow={false} />
			<RootContainer>
				<Title> {t("spin.ruleTitle")} </Title>
				<RulesContainer dangerouslySetInnerHTML={{ __html: ruleText }} />
			</RootContainer>
		</>
	);
};

export default Rules;
